import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { onMounted, ref } from "vue";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import SelectionDialog from "@/components/SelectionDialog/SelectionDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetCollectionDialog',
    props: {
        callback: { type: Function, default: () => { } },
        history: null,
        modalStatic: { type: Boolean, default: false }
    },
    emits: ["onCancel", "onOk", "onUpload"],
    setup(__props, { emit }) {
        const props = __props;
        const errorMessage = ref("");
        const items = ref([]);
        const modalShow = ref(true);
        const optionsShow = ref(false);
        function onClick(record) {
            modalShow.value = false;
            props.callback(record);
            emit("onOk", record);
        }
        /** Called when the modal is hidden */
        function onCancel() {
            modalShow.value = false;
            emit("onCancel");
        }
        /** Performs server request to retrieve data records **/
        function load() {
            optionsShow.value = false;
            const url = withPrefix(`/api/histories/${props.history}/contents?type=dataset_collection`);
            axios
                .get(url)
                .then((response) => {
                items.value = response.data.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                        time: item.created_time,
                        isLeaf: true,
                    };
                });
                optionsShow.value = true;
            })
                .catch((error) => {
                errorMessage.value = errorMessageAsString(error);
            });
        }
        onMounted(() => {
            load();
        });
        return { __sfc: true, props, emit, errorMessage, items, modalShow, optionsShow, onClick, onCancel, load, SelectionDialog };
    }
});
